module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9P8eI"))).then(() => module.bundle.root('d181N'));